// extracted by mini-css-extract-plugin
export default {"ogaWebsiteBox":"ogaWebsite_ogaWebsiteBox__Rk5nC"};